import { atom } from 'recoil';
export const forgotPasswordState = atom({
    key: 'forgotPasswordState',
    default: {
        isLoading: false,
        isFormInvalid: true,
        email: '',
        emailError: '',
        mainError: '',
        dirtyFields: {
            email: false
        }
    }
});
